export default __webpack_public_path__ + "static/media/loading.b33cf617.png";